import { ARTICLES_INDEX } from '../articles-index'

export function getArticle(path: string) {
  const safePath = path.split('#')[0] // remove hash
  return ARTICLES_INDEX.get(safePath)
}
